<template>
  <div class="Survey subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :active-name="menuName" />
    <!-- 大会概况 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 大会概况 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ name }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 内容 -->
          <div class="NewsCenter_cont sub_cont">
            <div class="content_txt" v-html="content"></div>
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <!-- 侧边栏 -->
        <ul class="sidebar">
          <li v-for="(item,index) in navList" :key="index" :class="activeName == item.name?'on':''" @click="SwitchTabFn(index)">{{ item.name }}</li>
        </ul>
        <!-- 内容 -->
        <div class="content_txt" v-html="content"></div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { SurveyApi,AccessRecordsApi } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  export default {
    name: "Survey",
    data() {
      return {
        content: '',
        name: '大会概况',
        ismobile: false,
        navList: [],
        activeName: '大会概况',
        menuName: ''
      }
    },
    created() {
      let wid = window.innerWidth;
      this.menuName = this.$route.query.name;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
    },
    mounted() {
      this.GetSurveyFn();
      
      this.AccessRecordsFn();
    },
    methods: {
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 4
        });
      },
      // tab切换
      SwitchTabFn(i) {
        this.activeName = this.navList[i].name;
        this.content = this.navList[i].content;
      },
      // 获取大会概况内容
      GetSurveyFn() {
        SurveyApi().then(res => {
          // this.name = res.seminarTopicName;
          this.navList = res.items;
          this.activeName = this.$route.query.subName ? this.$route.query.subName : res.items[1].name;
          for (let i = 0; i < res.items.length; i++) {
            if (this.activeName == res.items[i].name) {
              this.content = res.items[i].content;
              break;
            }
          }
        });
      }
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .content_txt {
      line-height: 30px;
      /* text-indent: 2em; */
      margin-top: 15px;
      font-size: 16px;
      text-align: justify;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .Survey_cont>img {
      width: 100%;
      height: auto;
      max-height: 3rem;
      margin-bottom: .4rem;
    }

    .Survey .Survey_cont {
      margin-bottom: .2rem;
    }

    .content_txt {
      font-size: .28rem !important;
      line-height: .48rem;
      text-align: justify;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Survey.vue